export const getMaxQuantity = (ticketData: any) => {
    return ticketData.availableSellingQuantities?.length > 0
        ? Math.max(...ticketData.availableSellingQuantities)
        : null;
};

// Generate quantity options dynamically per ticket
// If `lockedQuantity` is provided, any option whose value differs from it will be disabled.
export const getQuantityOptions = (
    ticketData: any,
    lockedQuantity?: number
) => {
    if (
        Array.isArray(ticketData?.availableSellingQuantities) &&
        ticketData.availableSellingQuantities.length > 0
    ) {
        const options = [
            ...ticketData.availableSellingQuantities.map((qty: number) => ({
                label: qty.toString(),
                value: qty,
                disabled: lockedQuantity !== undefined && qty !== lockedQuantity,
            })),
        ];

        return options;
    }
    // Fallback: just 0 or 1
    return [
        {
            label: '0',
            value: 0,
            disabled: lockedQuantity !== undefined && lockedQuantity !== 0,
        },
        {
            label: '1',
            value: 1,
            disabled: lockedQuantity !== undefined && lockedQuantity !== 1,
        },
    ];
};

// Get the first available quantity for a ticket (default value)
export const getFirstAvailableQuantity = (ticketData: any) => {
    if (
        ticketData.availableSellingQuantities &&
        Array.isArray(ticketData.availableSellingQuantities) &&
        ticketData.availableSellingQuantities.length > 0
    ) {
        return ticketData.availableSellingQuantities[0];
    }
    return 1; // Fallback
};

export const getFirstAvailableDeliveryMethod = (ticketData: any) => {
    if (ticketData.deliveryMethods && ticketData.deliveryMethods.length > 0) {
        return ticketData.deliveryMethods[0].id;
    }
    return null;
};